/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_OkInputs */

const en_lg_search_ok = /** @type {(inputs: Lg_Search_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titles and snippets appear only for conversations you can read. When access or connectivity changes, results are rechecked and old results are hidden.`)
};

const id_lg_search_ok = /** @type {(inputs: Lg_Search_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul dan cuplikan hanya muncul untuk percakapan yang boleh kamu baca. Jika izin atau koneksi berubah, hasil diperiksa ulang dan hasil lama disembunyikan.`)
};

/**
* | output |
* | --- |
* | "Titles and snippets appear only for conversations you can read. When access or connectivity changes, results are rechecked and old results are hidden." |
*
* @param {Lg_Search_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_ok = /** @type {((inputs?: Lg_Search_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_ok(inputs)
	return en_lg_search_ok(inputs)
});